import i18n from "./i18n";
import { $Dictionary } from "i18next/typescript/helpers";
import { TOptionsBase } from "i18next/typescript/options";

export const t: Function = (key: string | string[], options?: (TOptionsBase & $Dictionary) | undefined): string =>
  i18n.t(key, options);